import axios from 'axios'
// const BASE_URL = "//dev.hudongpai.com/api.php?s="; // 这是正式的
// const BASE_URL = "//2022.ithinky.com/hudongpai0718/server/public/api.php?s="; // 这是正式的

if (process.env.NODE_ENV === 'development') {
    // var BASE_URL = "https://kk.ithinky.com/api.php?s=";
    // var BASE_URL = "//2022.ithinky.com/hudongpai0718/server/public/api.php?s=";
    var BASE_URL = 'http://hdp.dev.com/api.php?s=';
    // var token = '745c8e24d2f00938421caedef3ea01e8';
    var token = '8801e2f4cf30ae08e223c7c4556cf0e5';
    window.BASE_URL = BASE_URL;
    window.token = token;
} else {
    var BASE_URL = "./api.php?s=";
    // var BASE_URL = "//2022.ithinky.com/hudongpai0718/server/public/api.php?s=";

    // var token = window.token; //  cookies.get('token');
    window.BASE_URL = BASE_URL;
    // window.token = token;
}

// create an axios instance
const service = axios.create({
    baseURL: BASE_URL, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000 // request timeout
})


// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        // config.headers['token'] = "07c7ad9473d4665dd8c60fa6e993636a";
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data


        // // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 200) {
        //     console.error(res);
        //    // alert(res.msg);
        //     // Message({
        //     //     message: res.msg || 'Error',
        //     //     type: 'error',
        //     //     duration: 5 * 1000
        //     // })

        //     // // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        //     // if (res.code === 1000) {
        //     //     store.dispatch('user/resetToken').then(() => {
        //     //         location.reload()
        //     //     })
        //     // }
        //     return Promise.reject(new Error(res.msg || 'Error'))
        // } else {
        //     return res
        // }
        return res;
    },
    error => {
        console.error(error);
        // console.log('err' + error) // for debug
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error)
    }
)

export default service;

export function get(url, params) {
    return new Promise((resolve, reject) => {
        service({ url: url, method: 'get', params }).then(res => {
            resolve(res);
        }).catch(e => {
            reject();
        })
    });
}


export function post(url, data) {
    return new Promise((resolve, reject) => {
        service({ url: url, method: 'post', data }).then(res => {
            resolve(res);
        }).catch(e => {
            reject(e);
        })
    });
}

export function upload(url, data) {
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            transformRequest: [
                function(data) {
                    let ret = '';
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                    }
                    ret = ret.substring(0, ret.lastIndexOf('&'));
                    return ret;
                }
            ],
        }).then(res => {
            resolve(res);
        }).catch(e => {
            reject(e);
        })
    });
}
